import React from "react";
import { CardStyle } from "./styles";

const Card = ({ icon, name, percent }) => {
	return (
		<CardStyle>
			<div className='triangle-top'></div>
			<div className='progress'>
				{icon}
				<svg className='circular'>
					<circle cx='50' cy='50' r='40'></circle>
					<circle
						style={{ strokeDashoffset: `calc(253 - (253 * ${percent}) / 100)` }}
						cx='50'
						cy='50'
						r='40'
					></circle>
				</svg>
			</div>
			<div className='skill-name'>
				<h4>{name}</h4>
				<p>{percent}%</p>
			</div>
		</CardStyle>
	);
};

export default Card;
